
const extractCustomFields = (elements) => {
  const customFields = new Set();

  const traverse = (items) => {
    items.forEach((item) => {
      if (item?.customField) {
        customFields.add(item.name);
      }
      if (item?.fields) {
        traverse(item.fields);
      }
      if (item?.sections) {
        traverse(item.sections);
      }
    });
  };

  traverse(elements);
  return Array.from(customFields);
};

export default extractCustomFields;
